import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {ProductComponent} from './product/product.component';
import {RequestMapperService} from "../request-mapper.service";

const routes: Routes = [
	{
		path: RequestMapperService.FABRIC_URL,
		pathMatch: "full",
		loadChildren: () => import('../filter/filter.module').then(m => m.FilterModule)
	},
	{
		path: RequestMapperService.FINISHED_URL,
		pathMatch: "full",
		loadChildren: () => import('../filter/filter.module').then(m => m.FilterModule)
	},
	{
		path:':category',
		component: ProductComponent
	},
	{
		path:':category/:id',
		component: ProductComponent
	},
	// {
	// 	path: ':category/:subCategory/:slug',
	// 	loadChildren: () => import('../product-details/product-details.module').then(m => m.ProductDetailsModule)
	// },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProductRoutingModule { }
